/**
  * 献礼外链 接口的统一出口
  */
import axios from '../http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const xlilinks = {
    // 列表
    list(params) {
        return axios.get(api + 'xlilinks/list', { params: params })
    },
    //添加
    create(params) {
        return axios.post(api + 'xlilinks/create', qs.stringify(params))
    },
    //获取编辑信息
    detail(params) {
        return axios.post(api + 'xlilinks/detail', qs.stringify(params))
    },
    //修改
    edit(params) {
        return axios.post(api + 'xlilinks/edit', qs.stringify(params))
    },
    //删除
    remove(params) {
        return axios.post(api + 'xlilinks/remove', qs.stringify(params))
    },
}


// 导出接口
export default xlilinks